import * as R from 'ramda';
import * as React from 'react';
import {FC} from 'react';
import {YMaps, Map, Placemark} from '@pbe/react-yandex-maps';

import styles from './map.module.css';
import {InfoPageLayout} from '../../components/info-page-layout/info-page-layout.component';
import {useFacilities} from '../../models/facilities/facilities-provider';
import {formatCoordinates, getLepIcon} from '../../utils/facility';

const MapPage: FC = () => {
  const {
    data = [],
  } = useFacilities();

  const facilities = data.filter((itm) => !R.isNil(itm.lat) && !R.isNil(itm.lng));

  return (
    <InfoPageLayout
      title="Карта присутствия"
    >
      <YMaps>
        <Map
          defaultState={{
            center: [56.010629, 92.852231],
            zoom: 12,
          }}
          className={styles.mapWrapper}
        >
          {
            facilities.map((itm, index) => (
              <Placemark
                key={index}
                geometry={formatCoordinates(itm)}
                properties={{
                  balloonContentHeader: itm.name,
                  balloonContentBody: itm.address || 'Адрес не указан',
                  balloonContentFooter: 'Кликните для закрытия',
                  hintContent: itm.name,
                }}
                modules={['geoObject.addon.balloon']}
                options={{
                  // preset: 'islands#blueIcon',
                  ...getLepIcon(),
                }}
              />
            ))
          }

        </Map>
      </YMaps>
    </InfoPageLayout>
  );
}

export default MapPage;